// Champs partages (js/event-fields.js) : prix normalise, heure, lien billetterie.
// Resolu a l'appel, pas au chargement : l'ordre des <script defer> est
// garanti par les pages, mais un module charge hors page (harnais de
// test, page oubliee) capturerait sinon `undefined` definitivement.
var NBF = new Proxy({}, { get: function (_t, k) {
  var f = window.LAgendaFields;
  if (!f) throw new Error('js/event-fields.js doit etre charge avant ' + 'cmdk-search.js');
  return f[k];
} });
(function(){
'use strict';

const esc = s => (s==null?'':String(s)).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const escAttr = s => (s==null?'':String(s)).replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
const $ = sel => document.querySelector(sel);
const $$ = sel => Array.from(document.querySelectorAll(sel));

const MONTHS = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
const MONTHS_SHORT = ['jan','fév','mars','avr','mai','juin','juil','août','sept','oct','nov','déc'];  // 'juin'/'juillet' se confondent en slice(0,3)

function normalize(s){
  return (s||'').toString().toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9]+/g,' ').trim();
}

function highlight(text, tokens){
  const safe = esc(text);
  if (!tokens || !tokens.length) return safe;
  const norm = normalize(text);
  if (!norm) return safe;
  const ranges = [];
  for (const t of tokens){
    if (!t) continue;
    let from = 0;
    while (true){
      const idx = norm.indexOf(t, from);
      if (idx === -1) break;
      ranges.push([idx, idx + t.length]);
      from = idx + t.length;
    }
  }
  if (!ranges.length) return safe;
  const orig = String(text);
  const map = [];
  let oi = 0;
  for (let ni = 0; ni < norm.length && oi <= orig.length; ){
    while (oi < orig.length){
      const c = normalize(orig[oi]);
      if (c === norm[ni]) { map[ni] = oi; oi++; ni++; break; }
      if (norm[ni] === ' ' && /[^a-z0-9]/i.test(orig[oi])){
        map[ni] = oi; oi++; ni++; break;
      }
      oi++;
    }
    if (oi > orig.length) break;
  }
  ranges.sort((a,b)=>a[0]-b[0]);
  const merged = [];
  for (const r of ranges){
    if (!merged.length || r[0] > merged[merged.length-1][1]) merged.push([r[0], r[1]]);
    else merged[merged.length-1][1] = Math.max(merged[merged.length-1][1], r[1]);
  }
  let out = '', cursor = 0;
  for (const [a, b] of merged){
    const oa = map[a] != null ? map[a] : 0;
    const ob = map[b-1] != null ? map[b-1] + 1 : orig.length;
    if (oa < cursor) continue;
    out += esc(orig.slice(cursor, oa));
    out += '<mark>' + esc(orig.slice(oa, ob)) + '</mark>';
    cursor = ob;
  }
  out += esc(orig.slice(cursor));
  return out;
}

const _ARTIST_SPLIT = /\s*(?:\+|&|\/|,| feat\.?| ft\.?| x | avec | with )\s+/i;
const _ARTIST_TRAIL = /\s+(?:live|tour|tournée|tournee|en concert|tour\s+\d{4}|world tour)\s*$/i;
function primaryArtist(eventName){
  if (!eventName) return '';
  let head = String(eventName).split(_ARTIST_SPLIT)[0].trim();
  head = head.replace(_ARTIST_TRAIL, '').trim();
  head = head.replace(/\s*\([^)]+\)\s*$/, '').trim();
  return head;
}

function artistSlug(name){
  if (!name) return '';
  let s = String(name);
  s = s.replace(/\s*\([^)]*(?:live|dj\s*set|concert|acoustic|solo|trio|quartet|quintet|set|tour|session)[^)]*\)/ig,'');
  s = s.replace(/\s+feat\..*$/i,'');
  s = s.replace(/\s*[-–]\s*(?:live|concert|tour|dj\s*set)\b.*$/i,'').trim();
  s = s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  s = s.replace(/[^\x00-\x7f]/g,'');
  s = s.replace(/[\s\u2013-]+(?:infernal )?tour.*$/,'');
  s = s.replace(/[\s\u2013-]+in concert.*$/,'');
  s = s.replace(/[\s\u2013-]+live.*$/,'');
  s = s.replace(/[\s\u2013-]+concert.*$/,'');
  s = s.replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  return s;
}

function shortGenre(g){
  if (!g) return '';
  const map = {
    'Pop & Variété':'Pop / Var.', 'Rap & Hip-Hop':'Rap', 'Jazz / Soul / Funk':'Jazz',
    'Métal / assimilés':'Metal', 'Reggae & World':'World', 'Musique de Film':'Ciné',
    'Folk / Indie':'Folk', 'Autre':'—'
  };
  return map[String(g).trim()] || String(g).trim();
}

// Meme prix que les cartes (chantier prix, 2026-10-20) : les bornes
// normalisees de l'event (event-fields.js parsePrice), plus le premier
// nombre du texte brut — « 18.95 € » pour une fourchette 15,95-18,95 €.
function parsePriceLabel(p, e){
  return NBF.parsePrice(p, e).label;
}

function normalizeEvent(e){
  const V = window.VENUES_LEGACY || {};
  const d = new Date(e.date + 'T00:00:00');
  // Salle de province (js/villes.js) : nom et preposition de data/villes.json.
  const s = !V[e.venue] && window.LAgendaVilles && window.LAgendaVilles.salle(e.venue);
  const v = V[e.venue]
    || (s && {slug:s.slug, prep:s.prep, display:s.nom, color:'var(--c60)', tone:'warm', capacity:s.capacite})
    || {slug:'other', prep:'à ', display:e.venue||'', color:'var(--c60)', tone:'warm', capacity:null};
  const sold = e.sale_status==='sold_out' || e.sold_out===true || e.sold_out===1;
  const cancelled = e.sale_status==='cancelled' || e.cancelled===true || e.cancelled===1;
  // Report : annonce de la salle, ou date deplacee detectee a l'ingestion.
  const postponed = !cancelled && (e.sale_status==='postponed' || !!NBF.newDate(e));
  const time = NBF.fmtTime(e.time);
  return {
    ...e,
    dateObj:d, venueMeta:v,
    time, sold, cancelled, postponed,
    // `status_uncertain` vaut 1 quand la salle n'a plus reconfirme le complet
    // depuis 14 jours (db_manager). Le test precedent cherchait « derniere »
    // dans un INTEGER : il n'a jamais rien matche.
    uncertain: NBF.isUncertain(e),
    soldLabel: NBF.soldOutLabel(e),
    priceLabel: parsePriceLabel(e.price, e),
    genreShort: shortGenre(e.genre||e.genre_raw||'Autre')
  };
}

// ---------- data ----------
let _events = null;
let _loadPromise = null;

async function loadEvents(){
  if (_events) return _events;
  if (_loadPromise) return _loadPromise;
  _loadPromise = (async () => {
    try {
      // Les concerts de la ville de la page (js/villes.js), Paris sinon.
      // Fichiers partages avec l'accueil (LAgendaVilles.events : un seul
      // telechargement par page, complements facultatifs).
      const villes = window.LAgendaVilles;
      const raw = villes && villes.events ? await villes.events()
        : await fetch('/data/events_upcoming.json').then(r => { if (!r.ok) throw new Error(r.status); return r.json(); });
      const V = window.VENUES_LEGACY || {};
      const known = name => V[name] || (villes && villes.salle(name));
      _events = raw
        .filter(e => e.date && e.event_name && e.venue && known(e.venue) && (e.category==null || e.category==='concert'))
        .map(normalizeEvent)
        .sort((a,b) => a.dateObj - b.dateObj || (a.time||'99:99').localeCompare(b.time||'99:99'));
    } catch (err){
      console.error('[cmdk] load events failed', err);
      _events = [];
    }
    return _events;
  })();
  return _loadPromise;
}

// External feed (home page already has events in memory).
function setEvents(events){
  if (!Array.isArray(events)) return;
  _events = events;
  _ARTIST_INDEX = null;
}

// ---------- search ----------
let _ARTIST_INDEX = null;
function buildArtistIndex(){
  if (_ARTIST_INDEX) return _ARTIST_INDEX;
  const idx = new Map();
  const now = new Date(); now.setHours(0,0,0,0);
  for (const e of (_events || [])){
    if (e.dateObj < now) continue;
    const name = primaryArtist(NBF.artistName(e));
    if (!name || name.length < 2) continue;
    const key = normalize(name);
    if (!key) continue;
    let entry = idx.get(key);
    if (!entry){
      entry = {key, name, events:[], soldCount:0, venues:new Set(), nextDate:null};
      idx.set(key, entry);
    }
    entry.events.push(e);
    if (e.sold) entry.soldCount++;
    entry.venues.add(e.venue);
    if (!entry.nextDate || e.dateObj < entry.nextDate) entry.nextDate = e.dateObj;
  }
  _ARTIST_INDEX = idx;
  return idx;
}

// ---------- salles ----------
// Toutes les salles qu'on connait, chacune rangee dans sa ville : celles de
// Paris (venues-data.js) et celles de province (js/villes.js). La recherche
// montre d'abord celles de la ville de la page, puis le reste de la France.
function allVenues(){
  const villes = window.LAgendaVilles;
  const rows = (window.VENUES_DATA||[]).map(v => ({
    ...v, names: v.names || [v.dbName], commune: v.city || 'Paris', ville: 'paris', villeNom: 'Paris'
  }));
  if (villes){
    for (const s of villes.salles()){
      const vv = villes.ville(s.ville);
      rows.push({display: s.nom, dbName: s.venue, names: [s.venue], commune: s.commune, capacity: s.capacite,
                 slug: s.slug, type: villes.taille(s), ville: s.ville, villeNom: vv ? vv.nom : s.commune});
    }
  }
  return rows;
}
function pageCity(){
  const villes = window.LAgendaVilles;
  const v = villes && villes.current();
  return v || {slug: 'paris', nom: 'Paris', a_nom: 'à Paris'};
}
// Salles de la ville de la page, les plus programmees d'abord.
function cityVenues(){
  const here = pageCity().slug;
  const counts = new Map();
  const now = new Date(); now.setHours(0,0,0,0);
  for (const e of (_events || [])) if (e.dateObj >= now) counts.set(e.venue, (counts.get(e.venue)||0) + 1);
  const n = v => v.names.reduce((s, name) => s + (counts.get(name)||0), 0);
  return allVenues().filter(v => v.ville === here)
    .map(v => ({...v, upcoming: n(v)}))
    .sort((a,b) => b.upcoming - a.upcoming || a.display.localeCompare(b.display, 'fr'));
}

function searchQuery(q){
  const needle = normalize(q);
  const empty = {tokens:[], artists:[], events:[], venues:[]};
  if (!needle || needle.length < 1) return empty;
  const tokens = needle.split(' ').filter(Boolean);
  const matches = (hay) => {
    const h = normalize(hay);
    return tokens.every(t => h.includes(t));
  };

  // Salles : celles de la ville de la page d'abord, puis le reste de la France
  // (« bordeaux » tape a Lyon liste les salles de Bordeaux).
  const here = pageCity().slug;
  const hit = v => matches(v.display) || matches(v.dbName) || matches(v.slug)
    || (v.commune && matches(v.commune)) || matches(v.villeNom);
  const all = allVenues().filter(hit);
  const venues = all.filter(v => v.ville === here)
    .concat(all.filter(v => v.ville !== here).map(v => ({...v, ailleurs: true})))
    .slice(0, 8);

  const artistIdx = buildArtistIndex();
  const artists = [];
  for (const a of artistIdx.values()){
    if (matches(a.name)) artists.push(a);
    if (artists.length >= 80) break;
  }
  artists.sort((a,b) => b.events.length - a.events.length || a.nextDate - b.nextDate);

  const now = new Date(); now.setHours(0,0,0,0);
  const events = [];
  const seen = new Set();
  for (const e of (_events || [])){
    if (e.dateObj < now) continue;
    const key = `${e.event_name}|${e.venue}|${e.date}`;
    if (seen.has(key)) continue;
    if (matches(e.event_name) || matches(e.venue) || matches((e.support_acts||[]).join(' '))){
      events.push(e);
      seen.add(key);
      if (events.length >= 40) break;
    }
  }
  events.sort((a,b) => a.dateObj - b.dateObj);

  return {tokens, artists:artists.slice(0,12), events:events.slice(0,30), venues};
}

// ---------- DOM injection ----------
const CMDK_DOM = `
<div class="cmdk-scrim" id="cmdk-scrim" aria-hidden="true"></div>
<div class="cmdk" id="cmdk" role="dialog" aria-modal="true" aria-label="Recherche" aria-hidden="true">
  <div class="cmdk-grain" aria-hidden="true"></div>
  <div class="cmdk-input">
    <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.2" y2="16.2"></line></svg>
    <input id="cmdk-input" type="text" placeholder="Chercher artiste, concert, salle…" autocomplete="off" spellcheck="false">
    <span class="count" id="cmdk-count" aria-live="polite"></span>
    <button class="esc" id="cmdk-close" type="button" aria-label="Fermer la recherche">Échap</button>
  </div>
  <div class="cmdk-chips" id="cmdk-chips" role="tablist"></div>
  <div class="cmdk-body" id="cmdk-body" role="listbox"></div>
  <div class="cmdk-foot">
    <div class="keys">
      <span class="k"><span class="kbd">↑</span><span class="kbd">↓</span> Naviguer</span>
      <span class="k"><span class="kbd">↵</span> Ouvrir</span>
      <span class="k"><span class="kbd">Tab</span> Filtrer</span>
    </div>
    <span class="brand">L'<b>Agenda</b> · ⌘K</span>
  </div>
</div>`;

function injectDom(){
  if ($('#cmdk')) return;
  const host = document.createElement('div');
  host.innerHTML = CMDK_DOM;
  while (host.firstChild) document.body.appendChild(host.firstChild);
}

// ---------- recherche sans résultat (GA4) ----------
// Envoyée quand la frappe s'arrête, à la fermeture ou au départ de la page,
// jamais à chaque lettre : jusqu'au 2026-09-27 chaque préfixe partait
// (« casi », « casin », « casino »…), 169 events pour 14 visiteurs en quatre
// semaines. Relue chaque nuit par scrapers/site_audience.py.
const NO_RESULT_IDLE_MS = 1500;
const _sentNoResult = new Set();
let _pendingNoResult = '';
let _noResultTimer = null;

function cancelNoResult(){
  if (_noResultTimer){ clearTimeout(_noResultTimer); _noResultTimer = null; }
  _pendingNoResult = '';
}

function flushNoResult(){
  const q = _pendingNoResult;
  cancelNoResult();
  if (!q || _sentNoResult.has(q)) return;
  _sentNoResult.add(q);
  track('search_no_result', { search_term: q.slice(0, 100) });
}

function scheduleNoResult(q){
  cancelNoResult();
  _pendingNoResult = q;
  _noResultTimer = setTimeout(flushNoResult, NO_RESULT_IDLE_MS);
}

// ---------- rendering ----------
const _CMDK = { open:false, filter:'all', results:null, rows:[], selIdx:0,
  inputEl:null, bodyEl:null, countEl:null, chipsEl:null };

const CHIP_TYPES = [
  {id:'all',      label:'Tout'},
  {id:'artistes', label:'Artistes'},
  {id:'concerts', label:'Concerts'},
  {id:'salles',   label:'Salles'},
];

function venueSwatchClass(meta){
  const tone = (meta && meta.tone) || '';
  if (tone === 'braise') return 'braise';
  if (tone === 'halo')   return 'halo';
  if (tone === 'cool')   return 'cool';
  return 'warm';
}

function renderArtistRow(a, tokens){
  const e0 = a.events[0] || null;
  const meta = e0 ? e0.venueMeta : null;
  const sw = venueSwatchClass(meta);
  const gVar = e0 && window.NB_GENRE_VAR ? window.NB_GENRE_VAR(e0.genre || e0.genre_raw) : null;
  const swStyle = gVar ? ` style="--_g:${gVar}"` : '';
  const ini = (a.name[0] || '?').toUpperCase();
  const V = window.VENUES_LEGACY || {};
  const venuesList = Array.from(a.venues).slice(0,3).map(n => V[n]?.display || n).join(' · ');
  const subBits = [];
  if (a.events.length > 1) subBits.push(`<em>${a.events.length} dates à venir</em>`);
  else if (a.events.length === 1) subBits.push(`<em>1 date</em>`);
  if (venuesList) subBits.push(`<b>${esc(venuesList)}</b>`);
  const right = a.soldCount > 0
    ? `<span class="sold">${a.soldCount} sold out</span>`
    : (a.events.length ? `<span>${a.events.length} date${a.events.length>1?'s':''}</span>` : '');
  const slug = artistSlug(a.name);
  return `<a class="row" data-kind="artist" data-key="${escAttr(a.key)}" href="/artiste/${escAttr(slug)}/" role="option">
    <span class="thumb"><span class="swatch ${sw}"${swStyle}></span><span class="typ">A</span><span class="ini">${esc(ini)}</span></span>
    <span class="main">
      <span class="title">${highlight(a.name, tokens)}</span>
      <span class="sub">${subBits.join(' <span class="dot">·</span> ')}</span>
    </span>
    <span class="right">${right}</span>
    <span class="arrow">→</span>
  </a>`;
}

// `postponed` etait calcule et jamais affiche : la recherche montrait le prix
// d'une date reportee comme d'un concert en vente. « Reporté au 12 fév. 2027 »
// quand la date reportee ecrit sa nouvelle date (`rescheduled_to`, derive a
// l'export par scrapers/public_payload.py) ; « Nouvelle date » pour celle qui
// remplace une date reportee : elle a lieu ce jour-la (NBF.newDate).
function postponedShort(e){
  const nd = NBF.newDate(e);
  if (nd) return nd.short;
  if (e.rescheduled_to) {
    const to = new Date(e.rescheduled_to + 'T00:00:00');
    if (!isNaN(to)) return `Reporté au ${to.getDate()} ${MONTHS_SHORT[to.getMonth()]}. ${to.getFullYear()}`;
  }
  return 'Reporté';
}

function renderEventRow(e, tokens){
  const v = e.venueMeta;
  const sw = venueSwatchClass(v);
  const gVar = window.NB_GENRE_VAR ? window.NB_GENRE_VAR(e.genre || e.genre_raw) : null;
  const swStyle = gVar ? ` style="--_g:${gVar}"` : '';
  const day = e.dateObj.getDate();
  const mo = MONTHS_SHORT[e.dateObj.getMonth()];
  const moCap = mo.charAt(0).toUpperCase() + mo.slice(1);
  const venueDisp = (v && v.display) || e.venue || '';
  const prep = (v && v.prep) ? v.prep : 'à ';
  const titleHtml = `${highlight(e.event_name, tokens)} ${esc(prep)}${highlight(venueDisp, tokens)}`;
  const subBits = [];
  if (e.time) subBits.push(esc(e.time));
  if (e.genreShort && e.genreShort !== '—') subBits.push(esc(e.genreShort));
  if (e.priceLabel && e.priceLabel !== '—' && !e.sold && !e.cancelled) subBits.push(`<b>${esc(e.priceLabel)}</b>`);
  if (e.sold) subBits.push(`<b style="color:var(--braise)">Sold out</b>`);
  else if (e.cancelled) subBits.push(`<b style="color:var(--braise)">Annulé</b>`);
  else if (e.postponed) subBits.push(`<b style="color:var(--braise)">${esc(postponedShort(e))}</b>`);
  // Canal du bouton epuise, la date pas forcement (event-fields.js channelSoldOut).
  else if (NBF.channelSoldOut(e)) subBits.push(`<b class="approx" title="${escAttr(NBF.channelSoldOut(e).long)}">${esc(NBF.channelSoldOut(e).short)}</b>`);
  // Une date sans artiste (`artist` vide : titre d'evenement) mene a sa fiche
  // ou a son lien (event-fields.js dateHref), jamais a « # ».
  const slug = artistSlug(primaryArtist(NBF.artistName(e)));
  const href = slug ? `/artiste/${slug}/` : (NBF.dateHref(e) || '#');
  return `<a class="row" data-kind="event" data-id="${escAttr(e.id)}" href="${escAttr(href)}" role="option">
    <span class="thumb"><span class="swatch ${sw}"${swStyle}></span><span class="ini" style="font-size:11px;letter-spacing:0">${esc(String(day).padStart(2,'0'))}.${esc(String(e.dateObj.getMonth()+1).padStart(2,'0'))}</span></span>
    <span class="main">
      <span class="title">${titleHtml}</span>
      <span class="sub">${subBits.join(' <span class="dot">·</span> ')}</span>
    </span>
    <span class="right"><span class="day">${day}</span><span class="mo">${esc(moCap)}</span></span>
    <span class="arrow">→</span>
  </a>`;
}

function renderVenueRow(v, tokens){
  const sw = (v.tone === 'braise') ? 'braise' : (v.tone === 'halo' ? 'halo' : (v.tone === 'cool' ? 'cool' : 'warm'));
  // Ou est la salle : sa ville quand ce n'est pas celle de la page (« Floirac ·
  // Bordeaux »), sa commune quand elle differe du nom de la ville.
  const commune = v.commune && v.commune !== v.villeNom ? v.commune : null;
  const where = v.ailleurs ? [commune, v.villeNom].filter(Boolean).join(' · ') : commune;
  const sub = [v.type, v.capacity ? `${v.capacity.toLocaleString('fr-FR')} places` : '', v.metro ? `M ${v.metro}` : '', where,
               v.upcoming ? `${v.upcoming} date${v.upcoming>1?'s':''} à venir` : ''].filter(Boolean).join(' · ');
  const arr = v.postal ? `${v.postal.slice(-2)}ᵉ arr.` : '';
  return `<a class="row" data-kind="venue" data-slug="${escAttr(v.slug)}" href="/salle/${escAttr(v.slug)}/" role="option">
    <span class="thumb"><span class="swatch ${sw}"></span><span class="typ">S</span></span>
    <span class="main">
      <span class="title">${highlight(v.display, tokens)}</span>
      <span class="sub">${esc(sub)}</span>
    </span>
    <span class="right">${v.capacity ? `<b>${v.capacity.toLocaleString('fr-FR')}</b><br>${esc(arr)}` : esc(arr)}</span>
    <span class="arrow">→</span>
  </a>`;
}

function renderChips(counts){
  const html = ['<span class="lbl">Filtrer</span>'];
  for (const c of CHIP_TYPES){
    const n = counts[c.id] || 0;
    const on = _CMDK.filter === c.id ? 'on' : '';
    html.push(`<button class="pchip ${on}" type="button" data-filter="${c.id}" role="tab" aria-selected="${on?'true':'false'}">${c.label} <span class="n">${n}</span></button>`);
  }
  _CMDK.chipsEl.innerHTML = html.join('');
  $$('#cmdk-chips .pchip').forEach(el => el.addEventListener('click', () => {
    _CMDK.filter = el.dataset.filter;
    refreshBody();
  }));
}

function renderResults(){
  const r = _CMDK.results;
  if (!r){ _CMDK.bodyEl.innerHTML = ''; return; }
  const counts = {
    all: r.artists.length + r.events.length + r.venues.length,
    artistes: r.artists.length,
    concerts: r.events.length,
    salles: r.venues.length,
  };
  renderChips(counts);
  _CMDK.countEl.innerHTML = counts.all
    ? `<b>${counts.all}</b> résultat${counts.all>1?'s':''}`
    : `<span style="color:var(--c40)">aucun résultat</span>`;

  if (counts.all === 0){
    const q = _CMDK.inputEl.value;
    // ≥ 3 caractères ; ne part qu'à l'arrêt de la frappe (scheduleNoResult)
    if (normalize(q).length >= 3) scheduleNoResult(q.trim());
    _CMDK.bodyEl.innerHTML = `<div class="empty"><b>Aucun résultat pour <em>« ${esc(q)} »</em></b>Essaie un nom d'artiste, une salle, ou un genre.</div>`;
    _CMDK.rows = [];
    return;
  }

  const showAll = _CMDK.filter === 'all';
  const tk = r.tokens;
  const html = [];

  if ((showAll || _CMDK.filter==='artistes') && r.artists.length){
    html.push(`<div class="group">`);
    html.push(`<div class="group-head"><span>— Artistes · ${r.artists.length}</span>${showAll && r.artists.length>3 ? `<button class="all" data-jump="artistes" type="button">Tout voir →</button>` : ''}</div>`);
    const list = showAll ? r.artists.slice(0,3) : r.artists;
    for (const a of list) html.push(renderArtistRow(a, tk));
    html.push(`</div>`);
  }
  if ((showAll || _CMDK.filter==='concerts') && r.events.length){
    html.push(`<div class="group">`);
    html.push(`<div class="group-head"><span>— Concerts · ${r.events.length}</span>${showAll && r.events.length>5 ? `<button class="all" data-jump="concerts" type="button">Tout voir →</button>` : ''}</div>`);
    const list = showAll ? r.events.slice(0,5) : r.events;
    for (const e of list) html.push(renderEventRow(e, tk));
    html.push(`</div>`);
  }
  if ((showAll || _CMDK.filter==='salles') && r.venues.length){
    html.push(`<div class="group">`);
    html.push(`<div class="group-head"><span>— Salles · ${r.venues.length}</span></div>`);
    for (const v of r.venues) html.push(renderVenueRow(v, tk));
    html.push(`</div>`);
  }
  _CMDK.bodyEl.innerHTML = html.join('');

  $$('#cmdk-body .all').forEach(el => el.addEventListener('click', ev => {
    ev.stopPropagation();
    _CMDK.filter = el.dataset.jump;
    renderResults();
  }));

  bindRows();
}

// Sans saisie : tendances et salles de la ville, ou toutes ses salles quand le
// filtre « Salles » est actif.
const LANDING_VENUES = 6;
function renderLanding(){
  _CMDK.countEl.innerHTML = `<span style="color:var(--c40)">tape pour chercher</span>`;
  const venues = cityVenues();
  renderChips({all:0, artistes:0, concerts:0, salles:venues.length});
  const city = pageCity();
  if (_CMDK.filter === 'salles'){
    _CMDK.bodyEl.innerHTML = venues.length
      ? `<div class="group"><div class="group-head"><span>— Salles ${esc(city.a_nom)} · ${venues.length}</span></div>${venues.map(v => renderVenueRow(v, [])).join('')}</div>`
      : `<div class="empty"><b>Aucune salle ${esc(city.a_nom)}</b></div>`;
    bindRows();
    return;
  }

  const idx = buildArtistIndex();
  const top = Array.from(idx.values())
    .sort((a,b) => b.events.length - a.events.length || a.nextDate - b.nextDate)
    .slice(0, 6);

  const html = [`<div class="cmdk-land">`];
  if (top.length){
    html.push(`<div class="land-head"><span>— Tendances</span><b>cette semaine</b></div>`);
    top.forEach((a, i) => {
      const cat = `${a.events.length} date${a.events.length>1?'s':''}` + (a.soldCount ? ` · ${a.soldCount} sold out` : '');
      html.push(`<div class="tr-row" data-q="${escAttr(a.name)}" role="option">
        <span class="rk">${String(i+1).padStart(2,'0')}</span>
        <div>
          <div class="tr-q">${esc(a.name)}</div>
          <div class="tr-cat">artiste · ${esc(cat)}</div>
        </div>
        <span class="tr-delta up">→</span>
      </div>`);
    });
  }
  if (venues.length){
    html.push(`<div class="land-head"><span>— Salles</span><b>${esc(city.a_nom)}</b></div>`);
    for (const v of venues.slice(0, LANDING_VENUES)) html.push(renderVenueRow(v, []));
    if (venues.length > LANDING_VENUES){
      html.push(`<button class="all land-all" type="button" data-jump="salles">Toutes les salles ${esc(city.a_nom)} (${venues.length}) →</button>`);
    }
  }
  html.push(`</div>`);
  _CMDK.bodyEl.innerHTML = html.join('');

  $$('#cmdk-body [data-q]').forEach(el => el.addEventListener('click', () => {
    _CMDK.inputEl.value = el.dataset.q;
    runQuery();
    _CMDK.inputEl.focus();
  }));
  $$('#cmdk-body .land-all').forEach(el => el.addEventListener('click', ev => {
    ev.stopPropagation();
    _CMDK.filter = 'salles';
    renderLanding();
    _CMDK.inputEl.focus();  // on peut continuer a taper
  }));
  $$('#cmdk-body .row').forEach(el => el.addEventListener('click', ev => activateRow(el, ev)));
  _CMDK.rows = $$('#cmdk-body .tr-row, #cmdk-body .row');
  _CMDK.selIdx = 0;
  highlightSelected();
}

// Filtre change : resultats de la saisie, ou accueil quand rien n'est tape.
function refreshBody(){
  if (_CMDK.results) renderResults();
  else renderLanding();
}

function bindRows(){
  _CMDK.rows = $$('#cmdk-body .row');
  _CMDK.selIdx = 0;
  highlightSelected();
  _CMDK.rows.forEach((el, i) => {
    el.addEventListener('mouseenter', () => { _CMDK.selIdx = i; highlightSelected(); });
    el.addEventListener('click', (ev) => activateRow(el, ev));
  });
}

// Envoi analytics tolérant à l'ordre de chargement : perf.js rejoue la file
// window.__trackQueue quand il arrive, puis la remplace par un passe-plat.
function track(name, params) {
  try {
    if (typeof window.trackEvent === 'function') window.trackEvent(name, params || {});
    else (window.__trackQueue = window.__trackQueue || []).push([name, params || {}]);
  } catch (_) {}
}

function activateRow(el, ev){
  const href = el.getAttribute('href') || '';
  track('search', {
    search_term: ((_CMDK.inputEl && _CMDK.inputEl.value) || '').trim().slice(0, 100),
    result_kind: el.getAttribute('data-kind') || '',
    result_href: href.slice(0, 200)
  });
  if (!href || href === '#'){
    if (ev) ev.preventDefault();
  }
  closeCmdK();
}

function highlightSelected(){
  _CMDK.rows.forEach((el, i) => el.classList.toggle('sel', i === _CMDK.selIdx));
  const sel = _CMDK.rows[_CMDK.selIdx];
  if (sel && sel.scrollIntoView) sel.scrollIntoView({block:'nearest'});
}

function moveSelection(delta){
  if (!_CMDK.rows.length) return;
  _CMDK.selIdx = (_CMDK.selIdx + delta + _CMDK.rows.length) % _CMDK.rows.length;
  highlightSelected();
}

function cycleFilter(direction){
  const i = CHIP_TYPES.findIndex(c => c.id === _CMDK.filter);
  const next = (i + direction + CHIP_TYPES.length) % CHIP_TYPES.length;
  _CMDK.filter = CHIP_TYPES[next].id;
  refreshBody();
}

let _deb = null;
function runQuery(){
  const q = _CMDK.inputEl.value;
  cancelNoResult();  // la frappe continue : le terme en attente n'était qu'un préfixe
  if (_deb) clearTimeout(_deb);
  _deb = setTimeout(() => {
    if (!q || normalize(q).length < 1){
      _CMDK.results = null;
      renderLanding();
      return;
    }
    _CMDK.results = searchQuery(q);
    _CMDK.filter = 'all';
    renderResults();
  }, 80);
}

async function openCmdK(prefill){
  if (_CMDK.open) return;
  _CMDK.open = true;
  $('#cmdk-scrim').classList.add('open');
  $('#cmdk-scrim').setAttribute('aria-hidden','false');
  $('#cmdk').classList.add('open');
  $('#cmdk').setAttribute('aria-hidden','false');
  document.body.style.overflow = 'hidden';
  if (prefill != null) _CMDK.inputEl.value = prefill;
  _CMDK.filter = 'all';
  setTimeout(() => _CMDK.inputEl.focus(), 30);
  if (!_events) await loadEvents();
  if (_CMDK.inputEl.value) runQuery();
  else renderLanding();
}

function closeCmdK(){
  if (!_CMDK.open) return;
  flushNoResult();  // fermer sans avoir trouvé = abandon : le terme compte
  _CMDK.open = false;
  $('#cmdk-scrim').classList.remove('open');
  $('#cmdk-scrim').setAttribute('aria-hidden','true');
  $('#cmdk').classList.remove('open');
  $('#cmdk').setAttribute('aria-hidden','true');
  document.body.style.overflow = '';
  _CMDK.inputEl.blur();
}

function bindTriggers(){
  const bind = el => {
    if (!el || el.dataset.cmdkBound) return;
    el.dataset.cmdkBound = '1';
    el.addEventListener('click', ev => { ev.preventDefault(); openCmdK(); });
    if (el.tagName !== 'BUTTON' && el.tagName !== 'A'){
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.addEventListener('keydown', ev => { if (ev.key === 'Enter' || ev.key === ' '){ ev.preventDefault(); openCmdK(); } });
    }
  };
  const trigger = document.getElementById('search-trigger');
  if (trigger) bind(trigger);
  $$('.search-inline').forEach(el => {
    el.style.cursor = 'pointer';
    bind(el);
  });
}

function setup(){
  injectDom();
  _CMDK.inputEl = $('#cmdk-input');
  _CMDK.bodyEl  = $('#cmdk-body');
  _CMDK.countEl = $('#cmdk-count');
  _CMDK.chipsEl = $('#cmdk-chips');

  $('#cmdk-close').addEventListener('click', () => closeCmdK());
  $('#cmdk-scrim').addEventListener('click', () => closeCmdK());

  _CMDK.inputEl.addEventListener('input', runQuery);
  _CMDK.inputEl.addEventListener('keydown', e => {
    if (e.key === 'Escape'){ e.preventDefault(); closeCmdK(); return; }
    if (e.key === 'ArrowDown'){ e.preventDefault(); moveSelection(1); return; }
    if (e.key === 'ArrowUp'){ e.preventDefault(); moveSelection(-1); return; }
    if (e.key === 'Enter'){
      e.preventDefault();
      const sel = _CMDK.rows[_CMDK.selIdx];
      if (!sel) return;
      if (sel.classList.contains('tr-row')){
        _CMDK.inputEl.value = sel.dataset.q || '';
        runQuery();
      } else {
        const raw = sel.getAttribute('href') || '';
        if (raw && raw !== '#'){ closeCmdK(); location.href = raw; }
        else closeCmdK();
      }
      return;
    }
    if (e.key === 'Tab'){ e.preventDefault(); cycleFilter(e.shiftKey ? -1 : 1); return; }
  });

  document.addEventListener('keydown', e => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k'){
      e.preventDefault();
      if (_CMDK.open) closeCmdK();
      else openCmdK();
    } else if (e.key === '/' && !_CMDK.open && !/INPUT|TEXTAREA/.test((document.activeElement||{}).tagName||'')){
      e.preventDefault();
      openCmdK();
    }
  });

  // Page quittée pendant l'attente : sendBeacon (perf.js) survit au départ.
  window.addEventListener('pagehide', flushNoResult);

  bindTriggers();
  // Re-scan after DOM insertions (e.g. other scripts adding search triggers).
  const mo = new MutationObserver(() => bindTriggers());
  mo.observe(document.body, {childList:true, subtree:true});

  try {
    const params = new URLSearchParams(location.search);
    const q = params.get('q') || params.get('recherche');
    if (q) openCmdK(q);
  } catch(_){}
}

window.LAgendaCmdk = { setEvents, openCmdK, closeCmdK };

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
else setup();

})();
